import type { ReactElement } from 'react';
import { useKeenSlider } from 'keen-slider/react';
import { Icon } from '@betrybe/ada-react';
import { useClient } from '@/hooks';
import CarouselCard from './CarouselCard';
import { stepsV2, stepsV3 } from './constants';
import FaqCard from './FaqCard';

function Carousel(): ReactElement {
  const [refCallback, slider] = useKeenSlider(
    {
      mode: 'free-snap',
      loop: false,
      initial: 0,
      breakpoints: {
        '(max-width: 455px)': {
          slides: {
            perView: 1,
            spacing: 15,
          },
        },
        '(min-width: 640px)': {
          slides: {
            perView: 1.5,
            spacing: 15,
          },
        },
        '(min-width: 1000px)': {
          slides: {
            perView: 2.5,
            spacing: 15,
          },
        },
      },
    },
    [],
  );
  const { stateMachineVersion } = useClient();
  const isV3 = stateMachineVersion === 'V3';
  const steps = isV3 ? stepsV3 : stepsV2;

  return (
    <>
      <div ref={refCallback} className="keen-slider">
        {steps.map((step) => (
          <div
            className="keen-slider__slide"
            key={step.id}
            style={{ maxWidth: '290px', minWidth: '290px', width: '100%' }}
          >
            <CarouselCard
              title={step.title}
              description={step.description}
              stepNumber={step.id}
              url={step.url}
              srcImage={step.srcImage}
            />
          </div>
        ))}

        {isV3 && <FaqCard />}
      </div>
      {slider && (
        <div className="keen-slider__action-buttons">
          <button onClick={() => slider.current?.prev()} aria-label="Retornar">
            <Icon height={18} width={18} color="blue" name="arrow_back_ios" />
          </button>

          <button onClick={() => slider.current?.next()} aria-label="Avançar">
            <Icon
              height={18}
              width={18}
              color="blue"
              name="arrow_forward_ios"
            />
          </button>
        </div>
      )}
    </>
  );
}

export default Carousel;
